import { call } from 'redux-saga/effects';
import { request } from '@wix/da-http-client/pkg/request';
export function* fetchGroupFolders(groupId, folderType) {
    const params = {
        groupid: groupId,
        type: folderType
    };
    const result = yield call(request, {
        method: 'get',
        url: 'deviation/group_folders',
        params
    }, ()=>{
        if (process.env.NODE_ENV !== 'production') {
            const collections = // eslint-disable-next-line global-require
            require('@wix/da-sample-data').collections;
            return {
                results: collections
            };
        }
        return {
            results: []
        };
    });
    return result;
}
export function* addDeviationToGroupFolder(groupFolderId, deviationId) {
    const data = {
        groupid: groupFolderId.groupId,
        type: groupFolderId.type,
        folderid: groupFolderId.folderId,
        deviationid: deviationId
    };
    const result = yield call(request, {
        method: 'post',
        url: 'deviation/group_add',
        data
    }, ()=>{
        return {
            success: true
        };
    }) || {
        success: false
    };
    return result;
}
